/**
 * useIsAdmin — hook do sprawdzenia „czy zalogowany user jest adminem" (UI).
 *
 * Rzetelna weryfikacja jest po stronie backendu (endpointy administracyjne
 * mają `_require_admin`). Ten hook służy WYŁĄCZNIE do decyzji UI —
 * pokazywać/ukrywać item menu, przekierować z chronionej strony.
 *
 * Mechanizm: backend zwraca `role="owner"` dla wszystkich (RBAC zniesiony).
 * Prawdziwy predykat to `email ∈ ADMIN_EMAILS` — znany tylko backendowi.
 * Heurystyka UI: strzelamy w `/creator-lock/diagnostics` (endpoint
 * admin-only, `_require_admin`). 200 → admin, 403 → nie.
 *
 * Zwraca:
 *   `null`   — pending (in-flight fetch),
 *   `true`   — admin,
 *   `false`  — non-admin.
 */
import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const useIsAdmin = () => {
  const [isAdmin, setIsAdmin] = useState(null);

  useEffect(() => {
    let cancelled = false;
    axios
      .get(`${API}/creator-lock/diagnostics`, { withCredentials: true })
      .then(() => !cancelled && setIsAdmin(true))
      .catch(() => !cancelled && setIsAdmin(false));
    return () => {
      cancelled = true;
    };
  }, []);

  return isAdmin;
};

export default useIsAdmin;
